export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href = 'https://learn.microsoft.com/en-us/powershell/module/exchange/set-remotedomain?view=exchange-ps';
